<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card max-width="400">
        <v-toolbar class="black--text" :color="$store.getters.stdColorLight">
          <v-row justify="center">
            <v-toolbar-title>{{ $t("message.errorTitle") }}</v-toolbar-title>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <p>
            <span v-show="this.$store.getters.errorDialog.sqlCode!=0" style="white-space: pre-line" v-html="getSqlErrorMessage()"></span>
            <span v-show="this.$store.getters.errorDialog.myErrorCode!=0" style="white-space: pre-line" v-html="getMyErrorMessage(this.$store.getters.errorDialog.myErrorCode)"></span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="$store.getters.stdColorDark" text @click="ok()">{{ $t("message.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  name: "optima-error-dialog",

  data: () => ({
    dialog: true,
  }),

  methods: {
    ok()
    {
      this.$store.dispatch("setErrorDialog", { showErrorDialog: false, sqlCode: 0, sqlState: "", sqlMessage: "", myErrorCode: 0 });
      this.dialog=false;
    },

    getSqlErrorMessage()
    {
      return "SQLCode: "+this.$store.getters.errorDialog.sqlCode.toString()+"\nSQLState: "+this.$store.getters.errorDialog.sqlState +"\n\n"+this.$store.getters.errorDialog.sqlMessage;
    },

    getMyErrorMessage(myErrorcode)
    {
      var retVal="";
      switch(myErrorcode) {
        case -1:
          retVal=this.$t("message.error_generic")
          break;
        case -2:
          retVal=this.$t("message.error_delete_ri")
          break;
        case -3:
          retVal=this.$t("message.error_update_no_entry")
          break;
        default:
          retVal=""
      }       
      return retVal;
    }

  }

};
</script>

<style scoped>
</style>
